module.exports = __webpack_public_path__ + "static/Datadog-b6f5e6450df161104ecce10b325ce13a.jpg";